module.exports = __webpack_public_path__ + "static/media/arrow-bottom.f5b2b92e.svg";